import React from "react";
import styled from "styled-components";
import SideMenu from "./SideMenu";
import Footer from "../Common/Footer";
import Nav from "../Common/Nav";
import RequireLogin from "../../permissions.js/RequireLogin";

function Aboutus() {
  return (
    <>
      <Nav />
      <Container>
        <TopSection>
          <NavigationInformation>
            Home &gt; My Profile &gt; About Us
          </NavigationInformation>
          <Title>About Us</Title>
        </TopSection>
        <BottomSection>
          <SideMenu />
          <PageInfo>
            <PageInfoTitle>About Us</PageInfoTitle>
            <Body>
              When you work with Hippocratic Financial Advisors, you have the
              assurance of working with an integrated team of financial
              specialists whose backgrounds, experience and credentials span
              multiple disciplines. <br /> <br /> Our role is to harmonize and
              simplify the management of your financial affairs while applying
              keen insight into the special issues facing physicians & dentists.
              By examining your unique circumstances through the lens of various
              wealth and risk management disciplines, we can provide a seamless,
              holistic solution for managing all aspects of your financial
              situation.
            </Body>
          </PageInfo>
        </BottomSection>
      </Container>
      <Footer />
    </>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 85vh;
  gap: 50px;
  padding: 0px 5vw;
`;

const TopSection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: 30px;
`;

const NavigationInformation = styled.div`
  color: var(--darkBlue);
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

const Title = styled.div`
  color: var(--darkBlue);
  font-family: Georgia;
  font-size: 55px;
  font-style: normal;
  font-weight: 400;
  line-height: 90%;
  letter-spacing: -1.1px;

  @media screen and (max-width: 719px) {
    font-size: 40px;
  }
`;

const BottomSection = styled.div`
  display: flex;
  gap: 30px;
`;

const PageInfoTitle = styled.div`
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 80% */
`;

const PageInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  flex: 1;
  height: 100%;
  background-color: #ecf3fb;
  border-radius: 20px;
  padding: 30px 35px;
`;

const Body = styled.div`
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px; /* 150% */
`;

export default RequireLogin(Aboutus);
